export const API_BASE_URLS = {
  EARNIPAY_STG: process.env.REACT_APP_API_BASE_URL || "",
  FEES_SERVICE: process.env.REACT_APP_API_FEES_SERVICE_BASE_URL || "",
  MEDIA_SERVICE: process.env.REACT_APP_API_MEDIA_SERVICE_BASE_URL || "",
  EARNIPAY_API: process.env.REACT_APP_EARNIPAY_API_BASE_URL || "",
  PAYMENTS: process.env.REACT_APP_PAYMENTS_BASE_URL || "",
  WALLET: process.env.REACT_APP_WALLET_BASE_URL || "",
};
